import Svg, {
  Defs,
  Ellipse,
  G,
  LinearGradient,
  Path,
  Stop,
} from 'react-native-svg';
import { TIllustrationProps } from '@/common/components/Illustrations/types';

export const IlustrationStep3 = ({
  width = 309,
  height = 300,
}: TIllustrationProps) => (
  <Svg width={width} height={height} fill="none">
    <G filter="url(#a)">
      <Path
        fill="url(#b)"
        fillRule="evenodd"
        d="M238.915 212c-1.108-21.264-8.802-42.287-23.293-59.386-33.837-39.936-91.897-43.305-129.666-7.535-18.88 17.877-29.119 42.135-30.42 66.921h183.379Z"
        clipRule="evenodd"
      />
    </G>
    <Ellipse cx={206.605} cy={163.53} fill="#fff" rx={36.676} ry={13.099} />
    <Path
      fill="#FDBD9A"
      fillRule="evenodd"
      d="M187.176 146.286c-10.73-10.73-10.73-28.127 0-38.857s28.127-10.73 38.858 0c10.73 10.73 10.73 28.127 0 38.857l-.045.045.002.002-19.386 19.385-19.299-19.299.002-.002a16.242 16.242 0 0 1-.132-.131Z"
      clipRule="evenodd"
    />
    <Path
      fill="#FF8E7A"
      d="M221.068 117.133c1.718 2.691.229 6.414-2.978 6.872h-.687a4.931 4.931 0 0 1-3.722-1.661 4.935 4.935 0 0 1-3.723 1.661c-1.489 0-2.863-.63-3.779-1.661-.859 1.031-2.234 1.661-3.723 1.661a4.931 4.931 0 0 1-3.722-1.661 4.933 4.933 0 0 1-3.722 1.661h-.688c-3.207-.458-4.696-4.181-2.978-6.872l3.265-5.154a1.54 1.54 0 0 1 1.374-.802h20.444c.573 0 1.088.286 1.375.802l3.264 5.154Z"
    />
    <Path
      fill="#fff"
      d="M219.065 125.666a2.913 2.913 0 0 1-.745.114c-.286.058-.63.058-.916.058-.687 0-1.374-.058-2.004-.287v7.617h-18.326v-7.617c-.687.229-1.374.287-2.061.287-.344 0-.63 0-.917-.058-.286 0-.515-.057-.687-.114v11.167c0 2.061 1.604 3.665 3.665 3.665H215.4a3.654 3.654 0 0 0 3.665-3.665v-11.167Z"
    />
    <Defs>
      <LinearGradient
        id="b"
        x1={55.535}
        x2={128.887}
        y1={120.31}
        y2={267.014}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#FE7165" />
        <Stop offset={1} stopColor="#FF8D78" />
      </LinearGradient>
    </Defs>
  </Svg>
);
